/* eslint-disable max-len */

import React, { useRef, useState } from 'react';
import { BookingState } from '../../modules/booking-state/BookingState';
import { useModalManager } from '../../modules/contexts/modal-manager-context/ModalManagerProvider';
import { AgreementWithoutServicePlanModalContent } from './agreement-without-service-plan-modal-content/AgreementWithoutServicePlanModalContent';
import { PriceEstimateWithoutServicePlanPageContext } from './PriceEstimateWithoutServicePlanPageContext';
import { PriceEstimateWithoutServicePlanPageFormData } from './PriceEstimateWithoutServicePlanPageFormData';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { withPageContext } from '../../modules/contexts/WithPageContext';
import { FormRef } from '../../modules/forms/Form';
import { Wizard, WizardNavigate } from '../../modules/wizard/Wizard';
import { Steps } from '../../modules/wizard/Steps';
import { useBookingContext } from '../../modules/booking-state/UseBookingContext';
import { PriceEstimateWithoutServicePlanPageViewProps } from './PriceEstimateWithoutServicePlanPageViewProps';

function ContextAccessor({
  vehicleDetails,
  vehicleServiceHistory,
  serviceRequest,
  selectedDealer,
  tcosEstimation,
}: BookingState): PriceEstimateWithoutServicePlanPageContext | null {
  if (!(tcosEstimation && vehicleDetails && vehicleServiceHistory && serviceRequest && selectedDealer)) {
    return null;
  }

  return {
    serviceRequest,
    vehicleServiceHistory,
    tcosEstimation,
  };
}

export const PriceEstimateWithoutServicePlanPage = withPageContext(ContextAccessor, ({ pageContext }) => {
  const viewProvider = useViewProvider();
  const [bookingState] = useBookingContext();
  const [initialFormData] = useState<PriceEstimateWithoutServicePlanPageFormData>(() => ({
    termsAndConditionsAccepted: false,
  }));
  const formRef = useRef<FormRef<PriceEstimateWithoutServicePlanPageFormData>>(null);
  const modalManager = useModalManager();
  const modalContent = AgreementWithoutServicePlanModalContent();

  const onNext: WizardNavigate = (nextStep) => {
    formRef.current!.submit(() => {
      nextStep(bookingState);
    });
  };
  const onPrevious: WizardNavigate = (previousStep) => {
    previousStep(bookingState);
  };
  const onTermsAndConditionsClick = (): void => {
    modalManager.open({
      title: 'Terms and conditions',
      content: () => modalContent,
    });
  };

  const viewProps: PriceEstimateWithoutServicePlanPageViewProps = {
    formRef,
    initialFormData,
    serviceRequest: pageContext.serviceRequest,
    tcosEstimation: pageContext.tcosEstimation,
    vehicleServiceHistory: pageContext.vehicleServiceHistory,
    onTermsAndConditionsClick,
  };

  return (
    <Wizard currentStep={Steps.EstimatedPrice} onNext={onNext} onPrevious={onPrevious} disabled={false}>
      {viewProvider.renderPriceEstimateWithoutServicePlanPage(viewProps)}
    </Wizard>
  );
});
